import React, { ReactNode } from 'react';
import { useTabs } from './TabsContext';
import styles from './Tabs.module.scss';

interface TabPanelProps {
  name: string;
  children: ReactNode;
}

const TabPanel = ({ name, children }: TabPanelProps) => {
  const { selectedTab } = useTabs();
  return (
    <div
      role="tabpanel"
      className={styles.tabPanel}
      style={{ display: selectedTab === name ? 'block' : 'none' }}
    >
      {children}
    </div>
  );
};

export default TabPanel;
